export default __webpack_public_path__ + "assets/images/5133dd65b7c199a7bdf774bf388360ed.svg";